// eslint-disable-next-line import/prefer-default-export
export const musicPlayerHeight = '7rem';
